import { render, staticRenderFns } from "./UpdateOrCreateEmployee.vue?vue&type=template&id=4a75b6f2"
import script from "./UpdateOrCreateEmployee.vue?vue&type=script&lang=js"
export * from "./UpdateOrCreateEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports